var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPager)?_c('div',{staticClass:"admin-pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"total, sizes, prev, pager, next, jumper","total":_vm.total,"current-page":_vm.page,"page-size":_vm.pageSize,"page-sizes":_vm.pageSizeOptions},on:{"current-change":_vm.onPageChange,"size-change":_vm.onSizeChange}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }